// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Orders_notes__Olial {\n\n    display: grid;\n\n    grid-template-columns: repeat( 2, 1fr );\n\n    grid-gap: 1rem;\n\n}", "",{"version":3,"sources":["webpack://./src/Pages/Orders/Orders.module.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;;IAEb,uCAAuC;;IAEvC,cAAc;;AAElB","sourcesContent":[".notes {\n\n    display: grid;\n\n    grid-template-columns: repeat( 2, 1fr );\n\n    grid-gap: 1rem;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notes": "Orders_notes__Olial"
};
export default ___CSS_LOADER_EXPORT___;
